module.exports = __webpack_public_path__ + "static/img/face26.7dd8cb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face26.jpg
// module id = w6VR
// module chunks = 0